<!-- Replaces fieldsDirective.js -->
<!-- TODO - how does this overlap with existing Vue components? e.g. custom fields -->
<template>
    <div data-component="Fields">
        <slot :field-groups="fieldGroups" />
    </div>
</template>

<script>
export default {
    name: 'Fields',

    props: {
        fieldGroupCollection: {
            type: Object,
            default: null,
        },

        hideNoValue: {
            type: Boolean,
            default: false,
        },
        /**
         * @type {'order' | 'item'}
         */
        level: {
            type: String,
            default: null,
        },
        // Starting from 1.
        lineNumber: {
            type: Number,
            default: null,
        },
        itemInstance: {
            type: Object,
            default: null,
        },
        itemInstanceIndex: {
            type: Number,
            default: null,
        },
        // These 2 x default: undefined fix https://digitickets.atlassian.net/browse/PROP-2828
        // TODO: Refactor fieldGroupCollection so don't have to pass in undefined.
        askEarly: {
            type: Boolean,
            default: undefined,
        },
        showToCustomers: {
            type: Boolean,
            default: undefined,
        },
    },

    computed: {
        fieldGroups() {
            if (!this.fieldGroupCollection) {
                return [];
            }

            return this.fieldGroupCollection.filterFieldGroups({
                hideNoValue: !!this.hideNoValue,
                level: this.level,
                lineNumber: this.lineNumber,
                itemInstance: this.itemInstanceIndex,
                askEarly: this.askEarly,
                showToCustomers: this.showToCustomers,
            });
        },
    },
};
</script>
